const API_BASE_URL = ''; // Relative path for proxy

export const ENDPOINTS = {
    LOGIN: `${API_BASE_URL}/api/auth/login`,
    CHAT: `${API_BASE_URL}/api/chat`,
    CHAT_HISTORY: `${API_BASE_URL}/api/chat/history`,
    CHAT_CLEAR: `${API_BASE_URL}/api/chat/clear`,
    BINGO_STATUS: `${API_BASE_URL}/api/bingo/status`,
    BINGO_UPDATE: `${API_BASE_URL}/api/bingo/update`,
    BINGO_UNDO: `${API_BASE_URL}/api/bingo/undo`,
    WEDDING_TASKS: `${API_BASE_URL}/api/wedding/tasks`,
    EXPENSES_DASHBOARD: `${API_BASE_URL}/api/expenses/dashboard`,
    EXPENSES_IMPORT: `${API_BASE_URL}/api/expenses/import`,
    EXPENSES_ENTRIES: `${API_BASE_URL}/api/expenses/entries`,
    // Immutable change history for ONE transaction. Deliberately a
    // per-record fetch: history hangs off transaction details, so the
    // ledger list never pays for it.
    EXPENSES_ENTRY_HISTORY: (id) => `${API_BASE_URL}/api/expenses/entries/${id}/history`,
    // Soft-deleted rows only. A separate read path on purpose: the dashboard
    // must never see a deleted record, and recovery must not depend on a
    // five-second toast holding the only id.
    EXPENSES_DELETED: `${API_BASE_URL}/api/expenses/deleted`,
    EXPENSES_ENTRY_RESTORE: (id) => `${API_BASE_URL}/api/expenses/entries/${id}/restore`,
    EXPENSES_SETTLEMENTS: `${API_BASE_URL}/api/expenses/settlements`,
    EXPENSES_QUERY: `${API_BASE_URL}/api/expenses/query`,
    HEALTH: `${API_BASE_URL}/api/health`,
    WEDDING_BUDGET: `${API_BASE_URL}/api/wedding/budget`,
    WEDDING_BUDGET_ITEMS: `${API_BASE_URL}/api/wedding/budget/items`,
    WEDDING_BUDGET_SETTINGS: `${API_BASE_URL}/api/wedding/budget/settings`,
    EXPENSES_FX_RATES: `${API_BASE_URL}/api/expenses/fx-rates`,
    EXPENSES_REBASE: `${API_BASE_URL}/api/expenses/rebase`,
    NOTES: `${API_BASE_URL}/api/notes`,
    ACTIVITY: `${API_BASE_URL}/api/activity`,
    CONTEXT: `${API_BASE_URL}/api/context`,
};

export const getAuthToken = () => localStorage.getItem('authToken');
export const setAuthToken = (token) => localStorage.setItem('authToken', token);
export const removeAuthToken = () => localStorage.removeItem('authToken');
export const isAuthenticated = () => !!localStorage.getItem('authToken');

export const getAuthHeaders = () => {
    const token = getAuthToken();
    return token ? {
        'Content-Type': 'application/json',
        'X-API-Key': token
    } : {
        'Content-Type': 'application/json'
    };
};

// Handle 401 responses by clearing token and redirecting to login
export const handleAuthError = (response) => {
    if (response.status === 401) {
        removeAuthToken();
        window.location.href = '/login';
        return true;
    }
    return false;
};
